import request from './request';

const propertyService = {
  getAllGroups: (params) =>
    request.get('dashboard/admin/property/groups', { params }),
  getGroupById: (id, params) =>
    request.get(`dashboard/admin/property/groups/${id}`, { params }),
  getGroupTypes: (params) =>
    request.get('dashboard/admin/property/groups/types', { params }),
  createGroup: (data) => request.post('dashboard/admin/property/groups', data),
  updateGroup: (id, data) =>
    request.put(`dashboard/admin/property/groups/${id}`, data),
  setGroupActive: (id) =>
    request.post(`dashboard/admin/property/groups/${id}/active`),
  deleteGroup: (data) =>
    request.delete(`dashboard/admin/property/groups/delete`, { data }),
  dropAllGroup: () => request.get(`dashboard/admin/property/group/drop/all`),
  restoreAllGroup: () =>
    request.get(`dashboard/admin/property/group/restore/all`),

  getAllValues: (params) =>
    request.get('dashboard/admin/property/values', { params }),
  getValueById: (id, params) =>
    request.get(`dashboard/admin/property/values/${id}`, { params }),
  createValue: (data) => request.post('dashboard/admin/property/values', data),
  updateValue: (id, data) => request.put(`dashboard/admin/property/values/${id}`, data),
  setValueActive: (id) =>
    request.post(`dashboard/admin/property/values/${id}/active`),
  deleteValue: (data) =>
    request.delete(`dashboard/admin/property/values/delete`, { data }),
  dropAllValue: () => request.get(`dashboard/admin/property/values/drop/all`),
  restoreAllValue: () =>
    request.get(`dashboard/admin/property/values/restore/all`),
};

export default propertyService;
